import moment from 'moment';
import React from 'react';
import {
  getImportEndDate,
  getImportPlatforms,
  getImportScanFor,
  getImportStartDate,
  getImportType,
} from 'selectors/import';
import { useSelector } from 'store';

export const platformMap = {
  outlook: 'Microsoft O365',
  teams: 'Microsoft Teams',
  gmail: 'Gmail',
};

export const scanMap = {
  none: 'None',
  email: 'Email',
  chat: 'Chat',
  'email-chat': 'Email and Chat',
};

const ImportReviewDetails: React.FC = () => {
  const type = useSelector(getImportType);
  const startDate = useSelector(getImportStartDate);
  const endDate = useSelector(getImportEndDate);

  const platforms = useSelector(getImportPlatforms);

  const scanFor = useSelector(getImportScanFor);

  return (
    <div className="flex flex-col gap-4 text-body bg-white">
      <span className="text-heading-3">Import Details</span>
      <div className="pl-8 flex flex-col gap-2">
        <p>
          {type === 'livestream' ? 'Livestream start date' : 'Lookback date range'}:{' '}
          <b>{moment(startDate).format('MM/DD/yyyy')}</b>
          {endDate && <b>–{moment(endDate).format('MM/DD/yyyy')}</b>}
        </p>
        <p>
          Platform permissions needed:{' '}
          <b>{platforms.map((p) => platformMap[p as keyof typeof platformMap]).join(',')}</b>
        </p>
        <p>
          <b>Scan attachments for {scanMap[scanFor as keyof typeof scanMap]}</b>
        </p>
      </div>
    </div>
  );
};

export default ImportReviewDetails;
